import { Link } from 'react-router-dom';
import { ICertificate } from '@/entities/Certificates';
import { AppImage } from '@/shared/ui/AppImage';
import FileIcon from '@/shared/assets/icons/file.svg';
import { Svg } from '@/shared/ui/Svg';
interface CertificatesProps {
  data: ICertificate[];
}

export const Certificates = ({ data }: CertificatesProps) => {
  if (!data || data.length === 0) {
    return <div className="text-grey-secondary">No certificates available</div>;
  }

  return (
    <div className="grid grid-cols-2 gap-6">
      {data.map((certificate) => {
        const url = certificate.imageFile?.url;
        return (
          <Link key={certificate.id} to={`/profile/certificates/${certificate.id}`} className="w-full rounded-[24px] overflow-hidden p-0 min-w-0 h-auto hover:opacity-90 transition-opacity cursor-pointer">
            {url ? (
              <AppImage
                src={url}
                alt={`Certificate ${certificate.certificateNumber}`}
                className="w-full h-full object-contain"
              />
            ) : (
              <div className="w-full aspect-[4/3] rounded-lg bg-neutral-100 flex flex-col gap-y-6 items-center justify-center">
                <Svg Icon={FileIcon} className="w-10 h-10" />
                <p className="text-grey-secondary">No preview available</p>
              </div>
            )}
          </Link>
        );
      })}
    </div >)
}
